import React from "react";
import { Modal, message } from "antd";
import {
  CreditCardOutlined,
  CopyOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_CONTACT_EMAIL } from "../subscription.service";

interface EnterpriseContactModalProps {
  open: boolean;
  onClose: () => void;
}

const EnterpriseContactModal: React.FC<EnterpriseContactModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation("subscription");
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(ENTERPRISE_CONTACT_EMAIL);
      message.success(t("enterpriseContact.copySuccess"));
    } catch {
      message.error(t("enterpriseContact.copyError"));
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      className="sub-modal"
    >
      <h3 className="sub-modal-title">{t("enterpriseContact.title")}</h3>
      <p className="sub-modal-sub">{t("enterpriseContact.subtitle")}</p>

      <div className="sub-contact-box">
        <div className="sub-contact-left">
          <span className="sub-pm-icon">
            <CreditCardOutlined />
          </span>
          <div>
            <div className="sub-contact-label">
              {t("enterpriseContact.contactLabel")}
            </div>
            <div className="sub-contact-email">{ENTERPRISE_CONTACT_EMAIL}</div>
          </div>
        </div>
        <button className="sub-copy-btn" onClick={handleCopy}>
          <CopyOutlined /> {t("enterpriseContact.copy")}
        </button>
      </div>

      <div className="sub-note">
        <InfoCircleOutlined className="ic" />
        <span>{t("enterpriseContact.note")}</span>
      </div>
    </Modal>
  );
};

export default EnterpriseContactModal;
